import dayjs from 'dayjs';

export const formatDateTime = (value) => {
  if (!value) return 'N/A';
  const date = dayjs(value);
 return date.isValid() ? date.format('DD MMM YYYY - HH:mm') : 'N/A';
};

export const formatDate = (value) => {
  if (!value) return 'N/A';
  const date = dayjs(value);
 return date.isValid() ? date.format('DD MMM YYYY') : 'N/A';
};

export const formatDurationHours = (start, end) => {
  const startDate = dayjs(start);
  const endDate = dayjs(end);
  if (!startDate.isValid() || !endDate.isValid()) return 'N/A';
  const minutes = endDate.diff(startDate, 'minute');
  if (minutes <= 0) return 'N/A';
  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hrs && mins) return `${hrs}h ${mins}m`;
  if (hrs) return `${hrs}h`;
  return `${mins}m`;
};

export const getInitials = (name = '') => {
  const parts = name.trim().split(/\s+/).slice(0, 2);
  return parts.map((part) => part.slice(0, 1).toUpperCase()).join('');
};

export default {
  formatDateTime,
  formatDate,
  formatDurationHours,
  getInitials,
};